<template>
  <div class="text-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="数据源" name="1">
        <div>
          <div class="data-source-type">
            <cx-slider :value.sync="noCacheComponent" :options="dataOptions" :height="32" />
          </div>
          <div v-show="!noCacheComponent" class="video-source-box">
            <div class="video-bgcard" v-if="videoTransferring">
              <div class="upload-transfer">
                <i class="icon-portal-transcoding"></i>
                <p class="text">视频转码中</p>
              </div>
            </div>
            <div class="video-bgcard" v-else>
              <div class="uploadfailed" v-if="percentage == 'error'">
                <i class="icon-portal-attention"></i>
                <p class="text">上传失败</p>
              </div>
              <div class="uploading" v-else-if="percentage > 0">
                <el-progress
                  type="circle"
                  :percentage="percentage"
                  :width="36"
                  :show-text="false"
                  :color="themeColor"
                ></el-progress>
                <p class="text">{{ percentage }}%</p>
              </div>
              <img :src="uploadVideoImg" alt="" v-else />
            </div>
            <div class="video-upload-box">
              <p class="tips">格式：FIV、MP4<br />大小：2G以下</p>
              <el-upload
                name="file"
                action="https://pan-yz.chaoxing.com/upload"
                :data="actionData"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-success="handleSuccessHandle"
                :on-error="handleFailHandle"
                :on-progress="handleProgressHandle"
                :show-file-list="false"
              >
                <button class="video-upload-btn">点击上传</button>
              </el-upload>
            </div>
          </div>
          <div v-show="noCacheComponent && pageType != 'detailPage' && !showColsFieldMapping" class="dataUrl-item video-upload-ipt">
            <el-input type="text" v-model="videoUrl" placeholder="请输入https://开头的地址"></el-input>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="(showColsFieldMapping && noCacheComponent) || (pageType === 'detailPage' && noCacheComponent)"
        title="数据绑定"
        name="2"
      >
        <div v-if="showColsFieldMapping && noCacheComponent" class="content">
          <colsFieldMappingSetting :ids="dataIds" :myId="ids" :options="options"></colsFieldMappingSetting>
        </div>
        <detailPageFieldMappingSetting v-else :myid="ids" :options="options"></detailPageFieldMappingSetting>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { isExist } from "utils/index"
import default_video_fm from "assets/images/image_placeholder.png"
import detailPageFieldMappingSetting from "publicSetting/detailPageFieldMappingSetting.vue"
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue"
import dataToolMixin from "materials/dataToolMixin"

export default {
  name: "video-options-data",
  components: { detailPageFieldMappingSetting, colsFieldMappingSetting },
  mixins: [dataToolMixin],
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      labelThree: false,
      activeNames: ["1", "2"],
      linkAddress: "无",
      // 视频上传
      dialogImageUrl: "",
      dialogVisible: false,
      actionData: {},
      percentage: 0
    }
  },
  mounted() {
    this.getUrl()
  },
  computed: {
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    videoUrl: {
      get() {
        return this.options.videoUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videoUrl", false)
      }
    },
    uploadVideoImg: {
      get() {
        return this.options.uploadVideoImg ? this.options.uploadVideoImg : default_video_fm
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "uploadVideoImg", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
        // 如果在详情页中文本组件选中外接数据源，需要先初始化文本组件在详情页的相关对象属性detailFieldMapping，同时给文本组件增加在详情页中请求数据源的插件
        if (this.pageType === "detailPage" && newVal) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataKey",
              fieldFlag: ""
            },
            "detailFieldMapping",
            false,
            false,
            false,
            true
          )
        }
      }
    },
    showColsFieldMapping() {
      return this.dataIds?.uid || isExist(this.dataIds?.elementInSwiperId) || this.dataIds?.elementInDataGridId
    },
    videoTransferring() {
      return this.options.videoTransferring || false
    },
    dataOptions() {
      const options = [{ value: false, title: "本地数据" }]
      if (this.showColsFieldMapping || this.pageType == 'detailPage') {
        options.push({ value: true, title: "数据绑定" })
      } else {
        options.push({ value: true, title: "视频地址" })
      }
      return options
    }
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleProgressHandle(response, file) {
      this.percentage = parseInt(file.percentage)
    },
    handleSuccessHandle(response, file, fileList) {
      if (response.result) {
        this.percentage = 0
        this.uploadVideoImg = response.data.thumbnail
        this.$changeOptionsEV(response.objectId, "objectId", false)
      } else {
        this.percentage = "error"
      }
    },
    handleFailHandle(err, file, fileList) {
      // console.log(err, file, fileList);
      console.log(err)
    },
    // 获取uid
    getUid() {
      let userInfo = this.$store.state.states.userInfo
      if (userInfo) {
        return userInfo.uid
      }
      return new Promise((resolve, reject) => {
        this.$API.getUserInfo().then(res => {
          if (res.data.code === 1) {
            resolve(res.data.data.uid)
          } else {
            reject("err")
          }
        })
      })
    },
    // 获取token
    getToken() {
      return new Promise((resolve, reject) => {
        this.instance.get("usts/yunpan/uservalid").then(res => {
          if (res.status == 200) {
            console.log("res token:>>", res)
            resolve(res.data)
          } else {
            reject("err")
          }
        })
      })
    },
    // 获取ip
    getUserIp() {
      return new Promise((resolve, reject) => {
        this.instance.get("/user/getUserIp").then(res => {
          if (res.data.code == 1 && res.data.data) {
            resolve(res.data.data)
          } else {
            reject("err")
          }
        })
      })
    },
    async getUrl() {
      let userIp = await this.getUserIp()
      let token = await this.getToken()
      // let token = "68a97b6e89af8ed91398035f530c4155"
      let uid = await this.getUid()
      this.actionData = {
        uploadtype: "normal",
        puid: uid,
        _from: "cdmh",
        _token: token
        // clientip: userIp,
      }
    }
  }
}
</script>

<style scoped>
.left-label {
  min-width: 60px;
}
.card {
  background: rgba(41, 44, 49, 1);
}
.count-limit-item/deep/ .el-input__inner {
  background: #35383f;
  padding: 0 12px;
  border-radius: 4px;
}

.setting-item .count-limit-item span {
  margin: 0 8px;
}
.setting-item .content-item .el-checkbox {
  margin-right: 20px;
}
.count-limit-item /deep/ .el-radio {
  margin-top: 7px;
  margin-bottom: 3px;
}

.count-limit-item /deep/ .el-radio:first-child {
  margin-top: 0;
}

.count-limit-item /deep/ .el-radio-group {
  width: 80px;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dataSource-item .link {
  color: var(--themeColor);
  cursor: pointer;
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: rgba(255, 255, 255, 0.2);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}
.video-bgcard {
  display: inline-block;
  vertical-align: top;
  width: 90px;
  height: 90px;
  border: 1px solid var(--sliderBackGround);
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
}

.video-upload-box {
  display: inline-block;
  vertical-align: top;
  margin-left: 16px;
  width: calc(100% - 112px);
}
.tips {
  margin-bottom: 26px;
  font-size: 12px;
  line-height: 17px;
}

.video-upload-box ::v-deep .el-upload--picture-card {
  width: 80px;
  height: 28px;
  line-height: 28px;
  border: none;
  background: none;
}
.video-upload-btn {
  width: 80px;
  height: 28px;
  border: 1px solid #3d82f2;
  box-sizing: border-box;
  border-radius: 4px;
  color: #3d82f2;
  font-size: 14px;
  line-height: 20px;
  background: transparent;
}
.video-source-box {
  margin-top: 8px;
}

.video-upload-ipt {
  margin-top: 8px;
}
.video-bgcard > img {
  width: 100%;
  height: 100%;
}
.uploading {
  width: 100%;
  height: 90px;
  background: var(--dataAddActiveBgColor);
  text-align: center;
  padding: 16px 0;
}
.uploading .text {
  font-weight: 600;
  font-size: 14px;
  color: var(--themeColor);
  margin-top: 8px;
  line-height: 20px;
}
.uploadfailed {
  width: 100%;
  height: 100%;
  background: rgba(255, 78, 78, 0.08);
  border: 1px solid #e9e9e9;
  text-align: center;
  color: #ff4e4e;
  padding: 15px;
  font-size: 16px;
}
.uploadfailed .text {
  font-size: 14px;
  line-height: 20px;
}
  .upload-transfer{
    width: 100%;
    height: 100%;
    background-color: #f6f7f9;
    border: 1px solid #e9e9e9;
    text-align: center;
    color: rgba(0,0,0,0.4);
    padding: 15px 0;
    font-size: 16px;
  }
.upload-transfer .text {
  font-size: 14px;
  line-height: 20px;
}
</style>
